import { render } from "./InfoPepAccionista_Juridico.vue?vue&type=template&id=0db59dc5"
import script from "./InfoPepAccionista_Juridico.vue?vue&type=script&lang=js"
export * from "./InfoPepAccionista_Juridico.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AG\\dev\\d_7\\_work\\54\\s\\AEL.DebidaDiligencia.FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__